import { Box, Button, DeleteDialog } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [name, setName] = useState("");
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onCancel = () => console.log("Delete cancelled");
	const onConfirm = () => console.log("Delete confirmed");
	const onButton = (value: string) => {
		setName(value);
		setOpen(true);
	};

	return (
		<Box>
			<CssColumnGrid columns={2}>
				<Button design="primary" onClick={() => onButton("")}>
					Delete Style with No Name
				</Button>
				<Button design="primary" onClick={() => onButton("Shirt 12345")}>
					Delete Style with Name
				</Button>
			</CssColumnGrid>
			<DeleteDialog
				nodeName={name}
				onCancel={onCancel}
				onClose={onClose}
				onConfirm={onConfirm}
				open={open}
				typeName="Style"
			/>
		</Box>
	);
};